/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CollaboType from './CollaboType';
import NftBoxGrade from './NftBoxGrade';
import NftBoxType from './NftBoxType';
import NftGenerateType from './NftGenerateType';
import NftGrade from './NftGrade';
import NftSeal from './NftSeal';
import NftType from './NftType';

/**
 * The NftImageGenerateModel model module.
 * @module model/NftImageGenerateModel
 * @version 1.0
 */
class NftImageGenerateModel {
    /**
     * Constructs a new <code>NftImageGenerateModel</code>.
     * @alias module:model/NftImageGenerateModel
     */
    constructor() { 
        
        NftImageGenerateModel.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>NftImageGenerateModel</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/NftImageGenerateModel} obj Optional instance to populate.
     * @return {module:model/NftImageGenerateModel} The populated <code>NftImageGenerateModel</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new NftImageGenerateModel();

            if (data.hasOwnProperty('nftUid')) {
                obj['nftUid'] = ApiClient.convertToType(data['nftUid'], 'Number');
            }
            if (data.hasOwnProperty('nftGenerateType')) {
                obj['nftGenerateType'] = NftGenerateType.constructFromObject(data['nftGenerateType']);
            }
            if (data.hasOwnProperty('nftType')) {
                obj['nftType'] = NftType.constructFromObject(data['nftType']);
            }
            if (data.hasOwnProperty('nftGrade')) {
                obj['nftGrade'] = NftGrade.constructFromObject(data['nftGrade']);
            }
            if (data.hasOwnProperty('nftSeal')) {
                obj['nftSeal'] = NftSeal.constructFromObject(data['nftSeal']);
            }
            if (data.hasOwnProperty('collabo')) {
                obj['collabo'] = CollaboType.constructFromObject(data['collabo']);
            }
            if (data.hasOwnProperty('plusFlag')) {
                obj['plusFlag'] = ApiClient.convertToType(data['plusFlag'], 'Boolean');
            }
            if (data.hasOwnProperty('isReveal')) {
                obj['isReveal'] = ApiClient.convertToType(data['isReveal'], 'Boolean');
            }
            if (data.hasOwnProperty('revealableAt')) {
                obj['revealableAt'] = ApiClient.convertToType(data['revealableAt'], 'Date');
            }
            if (data.hasOwnProperty('boxType')) {
                obj['boxType'] = NftBoxType.constructFromObject(data['boxType']);
            }
            if (data.hasOwnProperty('boxGrade')) {
                obj['boxGrade'] = NftBoxGrade.constructFromObject(data['boxGrade']);
            }
            if (data.hasOwnProperty('boxBlessed')) {
                obj['boxBlessed'] = ApiClient.convertToType(data['boxBlessed'], 'Boolean');
            }
            if (data.hasOwnProperty('count')) {
                obj['count'] = ApiClient.convertToType(data['count'], 'Number');
            }
            if (data.hasOwnProperty('engineCount')) {
                obj['engineCount'] = ApiClient.convertToType(data['engineCount'], 'Number');
            }
            if (data.hasOwnProperty('nftKey')) {
                obj['nftKey'] = ApiClient.convertToType(data['nftKey'], 'String');
            }
            if (data.hasOwnProperty('nftImageKey')) {
                obj['nftImageKey'] = ApiClient.convertToType(data['nftImageKey'], 'String');
            }
            if (data.hasOwnProperty('boxImageKey')) {
                obj['boxImageKey'] = ApiClient.convertToType(data['boxImageKey'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>NftImageGenerateModel</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>NftImageGenerateModel</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['nftKey'] && !(typeof data['nftKey'] === 'string' || data['nftKey'] instanceof String)) {
            throw new Error("Expected the field `nftKey` to be a primitive type in the JSON string but got " + data['nftKey']);
        }
        // ensure the json data is a string
        if (data['nftImageKey'] && !(typeof data['nftImageKey'] === 'string' || data['nftImageKey'] instanceof String)) {
            throw new Error("Expected the field `nftImageKey` to be a primitive type in the JSON string but got " + data['nftImageKey']);
        }
        // ensure the json data is a string
        if (data['boxImageKey'] && !(typeof data['boxImageKey'] === 'string' || data['boxImageKey'] instanceof String)) {
            throw new Error("Expected the field `boxImageKey` to be a primitive type in the JSON string but got " + data['boxImageKey']);
        }

        return true;
    }


}



/**
 * @member {Number} nftUid
 */
NftImageGenerateModel.prototype['nftUid'] = undefined;

/**
 * @member {module:model/NftGenerateType} nftGenerateType
 */
NftImageGenerateModel.prototype['nftGenerateType'] = undefined;

/**
 * @member {module:model/NftType} nftType
 */
NftImageGenerateModel.prototype['nftType'] = undefined;

/**
 * @member {module:model/NftGrade} nftGrade
 */
NftImageGenerateModel.prototype['nftGrade'] = undefined;

/**
 * @member {module:model/NftSeal} nftSeal
 */
NftImageGenerateModel.prototype['nftSeal'] = undefined;

/**
 * @member {module:model/CollaboType} collabo
 */
NftImageGenerateModel.prototype['collabo'] = undefined;

/**
 * @member {Boolean} plusFlag
 */
NftImageGenerateModel.prototype['plusFlag'] = undefined;

/**
 * @member {Boolean} isReveal
 */
NftImageGenerateModel.prototype['isReveal'] = undefined;

/**
 * @member {Date} revealableAt
 */
NftImageGenerateModel.prototype['revealableAt'] = undefined;

/**
 * @member {module:model/NftBoxType} boxType
 */
NftImageGenerateModel.prototype['boxType'] = undefined;

/**
 * @member {module:model/NftBoxGrade} boxGrade
 */
NftImageGenerateModel.prototype['boxGrade'] = undefined;

/**
 * @member {Boolean} boxBlessed
 */
NftImageGenerateModel.prototype['boxBlessed'] = undefined;

/**
 * @member {Number} count
 */
NftImageGenerateModel.prototype['count'] = undefined;

/**
 * @member {Number} engineCount
 */
NftImageGenerateModel.prototype['engineCount'] = undefined;

/**
 * @member {String} nftKey
 */
NftImageGenerateModel.prototype['nftKey'] = undefined;

/**
 * @member {String} nftImageKey
 */
NftImageGenerateModel.prototype['nftImageKey'] = undefined;

/**
 * @member {String} boxImageKey
 */
NftImageGenerateModel.prototype['boxImageKey'] = undefined;






export default NftImageGenerateModel;

